import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import MaterialTable from "@material-table/core";
import { ExportCsv } from "@material-table/exporters";

/*Import API*/
import { fetchGET, fetchDELETE } from "../apiHelper";
import {
  seznamUserjevAvtorizacije,
  brisanjeUporabnikovihAvtorizacij,
  seznamFakultetnihUserjevAvtorizacije,
} from "../listOfApi";

/*import Material-icons*/
import Search from "@material-ui/icons/Search";

/* React-Bootstrap component */
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";

import RoleGuard from "../auth/RoleGuard";
import { MODULES, ROLES } from "../auth/roles";
import AccessDenied from "./ui/AccessDenied";
import { BsCheck2, BsExclamationDiamond, BsPersonVcard } from "react-icons/bs";

import { Tooltip } from "react-tooltip";

const UserRolesAuthorisation = (props) => {
  const [usersList, setUsersList] = useState([]);
  const [userListFakultetni, setUserListFakultetni] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [idForRemoveUser, setIdForRemoveUser] = useState("");
  const [userUpn, setUserUpn] = useState("");
  const [showFilters, setShowFilters] = useState(false);

  const history = useNavigate();

  const lookupRoleValue = { 0: "Ni dostopa", 1: "Obiskovalec", 2: "Urednik" };

  const columns = [
    {
      title: "Uporabnik",
      field: "upn",
    },
    { title: "Programi", field: "programi", lookup: lookupRoleValue },
    { title: "Projekti", field: "projekti", lookup: lookupRoleValue },
    {
      title: "Projektni partnerji",
      field: "partnerji",
      lookup: lookupRoleValue,
    },
    {
      title: "Razpisi",
      field: "razpisi",
      lookup: lookupRoleValue,
    },
    {
      title: "Aktualni razpisi",
      field: "aktualniRazpisi",
      lookup: lookupRoleValue,
    },
    {
      title: "De minimis",
      field: "deminimis",
      lookup: lookupRoleValue,
    },
    {
      title: "Super admin",
      field: "admin",
      lookup: { true: "Da", false: "Ne" },
    },
  ];

  const columnsFakultetni = [
    {
      title: "Uporabnik",
      render: row => (
        <>
          {row.upn + " "} 
          {row.obstaja ? 
            "" : 
            <>
              <BsExclamationDiamond style={{color: "red", fontSize: "18px", marginRight: "5px", marginLeft: "3px"}} data-tooltip-id="icon1" />
              <Tooltip
                id="icon1"
                className="custom-tooltip"
                place="right"
              >
                <span>Osebe ni v imeniku!</span>
              </Tooltip>
            </>
          }
          {row.prikaziNaSeznamuKontaktnihOsebClanice ? 
          <>
            <BsPersonVcard style={{color: "#0090c1d9", fontSize: "18px", marginLeft: "3px"}} data-tooltip-id="icon2" /> 
            <Tooltip
              id="icon2"
              className="custom-tooltip"
              place="right"
            >
              <span>Oseba je na seznamu UM kontaktov</span>
            </Tooltip>
          </> :
          ""}
        </>
      )
    },
    { 
      title: "Članica",
      field: "clanica"
    },
  ];

  useEffect(() => {
    fetchGET(seznamUserjevAvtorizacije).then((usersRoles) => {
      if (usersRoles !== 0) {
        const users = usersRoles.map((item) => {
          return {
            id: item.id,
            upn: item.upn,
            programi: item.programi,
            projekti: item.projekti,
            partnerji: item.partnerji,
            razpisi: item.razpisi,
            aktualniRazpisi: item.aktualniRazpisi,
            deminimis: item.deminimis ?? item.Deminimis ?? 0,
            admin: item.admin,
          };
        });
        setUsersList(users);
      } else {
      }
    });
  }, []);

  useEffect(() => {
    fetchGET(seznamFakultetnihUserjevAvtorizacije).then((usersRoles) => {
      if (usersRoles !== 0) {
        const users = usersRoles.map((item) => {
          return {
            id: item.id,
            upn: item.upn,
            clanica: item.clanica,
            prikaziNaSeznamuKontaktnihOsebClanice: item.prikaziNaSeznamuKontaktnihOsebClanice,
            obstaja: item.obstaja
          };
        });
        setUserListFakultetni(users);
      } else {
      }
    });
  }, []);

  const handleUserDelete = () => {
    fetchDELETE(`${brisanjeUporabnikovihAvtorizacij}/${idForRemoveUser}`).then(
      (deleted) => {
        if (deleted === 1) {
          setShowModal(false);
          window.location.reload();
        } else {
          //TODO: prišlo je do napake pri brisanju podatkov.
        }
      },
    );
  };

  return (
    <RoleGuard
      moduleKey={MODULES.AVTORIZACIJE}
      roles={[ROLES.GLOBALNI_ADMINISTRATOR]}
      fallback={<AccessDenied />}
    >
      <Container fluid>
        <Modal
          show={showModal}
          onHide={() => {
            setShowModal(false);
          }}
        >
          <Modal.Body>
            Želite izbrisati uporabnika: <strong>{userUpn}</strong> ?
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="btn btn-danger"
              variant="secondary"
              onClick={handleUserDelete}
            >
              Izbriši
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                setShowModal(false);
              }}
            >
              Ne
            </Button>
          </Modal.Footer>
        </Modal>
        <Row>
          <Col className="main-header font-weight-bold">Avtorizacije</Col>
        </Row>
        <Row>
          <Col className="header-divider">
            <hr />
          </Col>
        </Row>
        <Row>
          <Col>
            <Tabs defaultActiveKey="globalneAvtorizacije">
              <Tab
                eventKey="globalneAvtorizacije"
                title="Globalne avtorizacije"
              >
                <Row>
                  <Col>
                    <div className="float-end mt-3">
                      <Link
                        className="programs-button-add-text"
                        to={`/Avtorizacije/Dodaj`}
                      >
                        <Button variant="outline-primary">
                          Nova avtorizacija
                        </Button>
                      </Link>
                    </div>
                  </Col>
                </Row>
                <Row className="mt-4">
                  <Col>
                    <MaterialTable
                      icons={{
                        Filter: () => <Search style={{ fontSize: "15px" }} />,
                      }}
                      title=""
                      columns={columns}
                      data={usersList}
                      localization={{
                        toolbar: {
                          searchPlaceholder: "Iskalnik",
                          exportCSVName: "Izvozi podatke v CSV",
                        },
                        header: { actions: "Akcije" },
                        body: {
                          emptyDataSourceMessage: "Ni zapisov za prikaz",
                        },
                        pagination: {
                          labelRowsSelect: "Vrstic",
                          firstAriaLabel: "Prva stran",
                          firstTooltip: "Prva stran",
                          previousAriaLabel: "Prejšnja stran",
                          previousTooltip: "Prejšnja stran",
                          nextAriaLabel: "Naslednja stran",
                          nextTooltip: "Naslednja stran",
                          lastAriaLabel: "Zadnja stran",
                          lastTooltip: "Zadnja stran",
                          labelDisplayedRows: "{from}-{to} od {count}",
                        },
                      }}
                      options={{
                        paging: true,
                        pageSize: 50,
                        pageSizeOptions: [50, 100, 500],
                        searchFieldAlignment: "left",
                        filtering: showFilters,
                        actionsColumnIndex: -1,
                        headerStyle: { fontWeight: "bold" },
                        exportMenu: [
                          {
                            label: "Izvozi podatke v CSV",
                            exportFunc: (cols, datas) =>
                              ExportCsv(
                                cols,
                                datas,
                                `avtorizacije_${new Date()
                                  .toLocaleDateString("sl-SI")
                                  .replace(/\. /g, "-")}`,
                              ),
                          },
                        ],
                      }}
                      actions={[
                        {
                          icon: "edit",
                          tooltip: "Uredi",
                          onClick: (event, rowData) => {
                            history(`/avtorizacije/uredi/${rowData.id}`);
                          },
                        },
                        {
                          icon: "delete",
                          tooltip: "Odstrani",
                          iconProps: { color: "error" },
                          onClick: (event, rowData) => {
                            setIdForRemoveUser(rowData.id);
                            setUserUpn(rowData.upn);
                            setShowModal(true);
                          },
                        },
                        {
                          icon: "filter_alt",
                          tooltip: "Omogoči filter",
                          isFreeAction: true,
                          onClick: (event) => {
                            setShowFilters(!showFilters);
                          },
                        },
                      ]}
                    />
                  </Col>
                </Row>
              </Tab>
              <Tab
                eventKey="fakultetneAvtorizacije"
                title="Fakultetne avtorizacije"
              >
                <Row>
                  <Col>
                    <div className="float-end mt-3">
                      <Link
                        className="programs-button-add-text"
                        to={`/Avtorizacije/DodajFakultetnega`}
                      >
                        <Button variant="outline-primary">
                          Nova fakultetna avtorizacija
                        </Button>
                      </Link>
                    </div>
                  </Col>
                </Row>
                <Row className="mt-4">
                  <Col>
                    <MaterialTable
                      icons={{
                        Filter: () => <Search style={{ fontSize: "15px" }} />,
                      }}
                      title=""
                      columns={columnsFakultetni}
                      data={userListFakultetni}
                      localization={{
                        toolbar: {
                          searchPlaceholder: "Iskalnik",
                          exportCSVName: "Izvozi podatke v CSV",
                        },
                        header: { actions: "Akcije" },
                        body: {
                          emptyDataSourceMessage: "Ni zapisov za prikaz",
                        },
                        pagination: {
                          labelRowsSelect: "Vrstic",
                          firstAriaLabel: "Prva stran",
                          firstTooltip: "Prva stran",
                          previousAriaLabel: "Prejšnja stran",
                          previousTooltip: "Prejšnja stran",
                          nextAriaLabel: "Naslednja stran",
                          nextTooltip: "Naslednja stran",
                          lastAriaLabel: "Zadnja stran",
                          lastTooltip: "Zadnja stran",
                          labelDisplayedRows: "{from}-{to} od {count}",
                        },
                      }}
                      options={{
                        paging: true,
                        pageSize: 50,
                        pageSizeOptions: [50, 100, 500],
                        searchFieldAlignment: "left",
                        filtering: showFilters,
                        actionsCellStyle: {
                          display: "flex",
                          justifyContent: "center",
                          padding: "3px",
                          width: "100%",
                        },
                        actionsColumnIndex: -1,
                        headerStyle: { fontWeight: "bold" },
                        exportMenu: [
                          {
                            label: "Izvozi podatke v CSV",
                            exportFunc: (cols, datas) =>
                              ExportCsv(
                                cols,
                                datas,
                                `avtorizacije_${new Date()
                                  .toLocaleDateString("sl-SI")
                                  .replace(/\. /g, "-")}`,
                              ),
                          },
                        ],
                      }}
                      actions={[
                        {
                          icon: "edit",
                          tooltip: "Uredi",
                          onClick: (event, rowData) => {
                            history(
                              `/avtorizacije/uredi/fakultetni/${rowData.id}`,
                            );
                          },
                        },
                        {
                          icon: "delete",
                          tooltip: "Odstrani",
                          iconProps: { color: "error" },
                          onClick: (event, rowData) => {
                            setIdForRemoveUser(rowData.id);
                            setUserUpn(rowData.upn);
                            setShowModal(true);
                          },
                        },
                        {
                          icon: "filter_alt",
                          tooltip: "Omogoči filter",
                          isFreeAction: true,
                          onClick: (event) => {
                            setShowFilters(!showFilters);
                          },
                        },
                      ]}
                    />
                  </Col>
                </Row>
              </Tab>
            </Tabs>
          </Col>
        </Row>
      </Container>
    </RoleGuard>
  );
};

export default UserRolesAuthorisation;
